module.exports = __webpack_public_path__ + "img/process-4.e6f0888a.png";